import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsCancelNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M6.879 9L9 6.88l15 15 15-15L41.121 9l-15 15 15 15L39 41.121l-15-15-15 15-2.121-2.12 15-15z"
        fill=""
      />
    </svg>
  )
);
SvgActionsCancelNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsCancelNormalLarge;
